import * as React from "react";
import { forwardRef } from "react";
const SvgAddons = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M16.1696 4.33037C15.7232 3.88395 15 3.88395 14.5536 4.33037L10.9732 7.9018L8.88393 5.81252L12.4554 2.23216C12.9018 1.79466 12.9018 1.06252 12.4554 0.616089C12.0089 0.178589 11.2857 0.178589 10.8393 0.616089L7.26786 4.19645L5.92857 2.85716L4.5 4.28573C2.54464 6.24109 2.26786 9.22323 3.73214 11.4375L0.5 14.6697V16.2857H2.11607L5.34821 13.0536C7.5625 14.5179 10.5446 14.2411 12.5 12.2857L13.9286 10.8572L12.5893 9.51788L16.1696 5.94645C16.6071 5.50002 16.6071 4.7768 16.1696 4.33037Z" }));
const ForwardRef = forwardRef(SvgAddons);
export default ForwardRef;
